<template>
    <div class="sidenav" id="myNavbar">
        <ul class="nav nav-pills nav-stacked" >
            <li><router-link to="/"><v-icon class="icon_size" >home</v-icon>Home</router-link></li>
            <li v-if="isLoggedIn"><router-link to="/student" ><v-icon class="icon_size">account_box</v-icon>Profile</router-link></li>
            <li><router-link to="/trackvisa"><v-icon class="icon_size">flight_takeoff</v-icon>Track my VISA</router-link></li> 
            <li v-if="!isLoggedIn"  class="show_header_items" ><router-link to="/login" ><v-icon class="icon_size">account_box</v-icon>Login</router-link></li>
            <li v-if="!isLoggedIn" class="show_header_items"><router-link to="/signup" ><v-icon class="icon_size">account_box</v-icon>Sign Up</router-link></li>
        </ul><br>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    name: 'Sidebar',
    isActive: false,
    computed: {
        ...mapGetters(['isLoggedIn'])
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Sidebar.vue